import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useLazyQuery } from '@apollo/client';
import { PAGE_INFORMATION_QUERY } from 'Graph/SiteGraph';
import {
  Box,
  Container,
  Typography
} from '@mui/material';
import PageLoadingSkeleton from 'Components/skeletons/PageLoadingSkeleton';

const ComingSoon = () => {
  const location = useLocation();
  const [pageInformationData, setPageInformationData] = useState(null)
  const [getLazyPageInformation, lazyPageInformation] = useLazyQuery(PAGE_INFORMATION_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only', // Used for first execution
    nextFetchPolicy: 'cache-first', // Used for subsequent executions
  });
  useEffect(() => {
    getLazyPageInformation({
      variables: { sidebarURL: location.pathname },
      onCompleted: ((info) => {
        setPageInformationData(info.pageConn.edges.map((edge) => edge.node))
      })
    })
  }, [])
  if (pageInformationData === null) return <PageLoadingSkeleton variant={"rectangular"} marginx={0} marginy={0} count={1} height={500} />


  // console.log(pageInformationData[0], location.pathname)
  return (
    <>
      <Helmet>
        <title>{`${pageInformationData[0].title}`}</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="md">
          <Typography
            align="center"
            color="textPrimary"
            variant="h1"
          >
            {pageInformationData[0].content}
            {/* The page you are looking for isn’t here yet. We are actively working on bringing this alive. */}
          </Typography>
          <Typography
            align="center"
            color="textPrimary"
            variant="subtitle2"
          >
            {pageInformationData[0].sub_content}
            {pageInformationData[0].contact_email}
          </Typography>
          <Box sx={{ textAlign: 'center' }}>
            <img
              alt="Under development"
              src="/static/images/not_found.png"
              style={{
                marginTop: 50,
                display: 'inline-block',
                maxWidth: '100%',
                width: 560
              }}
            />
          </Box>
        </Container>
      </Box>
    </>
  )
}


export default ComingSoon;
